export default __webpack_public_path__ + "static/media/1.86b6db3d.png";